<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { COR_DA_SITUACAO, prazoAtual } from './helpers';

const props = defineProps({
  chamado: { type: Object, required: true },
});

const { t } = useI18n();

// Chamado sem SLA não mostra prazo; o status aparece sempre.
const situacao = computed(() => {
  const codigo = prazoAtual(props.chamado)?.situacao;
  return COR_DA_SITUACAO[codigo] ? codigo : null;
});
</script>

<template>
  <span class="flex items-center gap-1 shrink-0">
    <span class="px-2 py-0.5 text-xs rounded-md bg-n-alpha-2 text-n-slate-12">
      {{ t(`SUPORTE_AMSHIFT.STATUS.${chamado.status}`) }}
    </span>
    <span
      v-if="situacao"
      class="px-2 py-0.5 text-xs rounded-md"
      :class="COR_DA_SITUACAO[situacao]"
    >
      {{ t(`SUPORTE_AMSHIFT.SITUACAO.${situacao}`) }}
    </span>
  </span>
</template>
